import appSettings from '@/appsettings.json';
import { SessionContext } from "@/context/SessionContext";
import { ProjectSubmission } from '@/javascript/project-objects';
import {
	Card,
	Group,
	Image, Stack, Text, useMantineTheme
} from "@mantine/core";
import { IconPlayerPlay } from '@tabler/icons-react';
import { useContext, useState } from "react";
import ProjectSubmissionVideoModal from './ProjectSubmissionVideoModal';

type VideoBlockProps = {
	projectSubmission: ProjectSubmission,
};

const VideoBlock: React.FC<VideoBlockProps> = ({ projectSubmission }) => {
	const theme = useMantineTheme()
	const [showModal, setShowModal] = useState<boolean>(false);
	const [hover, setHover] = useState<boolean>(false);

	const session = useContext(SessionContext);
	if (session === undefined) {
		throw new Error("VideoBlock must be a child of SessionContext.");
	}

	return (
		<>
			<Group
				onMouseEnter={() => setHover(true)}
				onMouseLeave={() => setHover(false)}
				onClick={() => setShowModal(true)}
				style={{
					flex: 1,
					position: "relative",
					overflow: "visible",
					minWidth: 300,
					maxWidth: 300,
					flexWrap: "wrap" as const,
					cursor: "pointer",
					transition: "0.5s"
				}}
			>
				<Card
					withBorder={true}
					radius="md"
					p="md"
					bg="#E8F1F9"
					style={{
						width: "100%",
						display: "flex",
						position: "relative",
						overflow: "visible",
						minHeight: 300,
						cursor: "pointer",
						flexDirection: "column" as const
					}}
				>
					<Card.Section>
						<Image
							src={`${appSettings.S3BucketBaseUrl}SubmissionThumbnails/${projectSubmission.id}.jpg`}
							height={180}
							width="100%"
							style={{ borderRadius: "var(--mantine-radius-md)", objectFit: "cover", width: "100%" }} />
						{hover && (
							<IconPlayerPlay
								size={"50"}
								color={"white"}
								style={{
									position: "absolute",
									left: "0",
									top: "0"
								}}
							/>
						)}
					</Card.Section>

					<Card.Section pb={10} pt="md">
						<Stack justify="apart">
							<Text
								pl={10}
								// c={theme.colors.blue[0]}
								// bg={theme.colors.blue[8]}
								fz="lg"
								fw={500}
							>
								{projectSubmission.submissionProjectName}
							</Text>
							{session.user?.classroomId != null && projectSubmission.projectOwner?.classroomId === session.user?.classroomId &&
								<Text fz="md" fw={500} pl={10} c={theme.colors.blue[8]}>
									{projectSubmission.projectOwner?.username}
								</Text>
							}
							<Text fz="sm" fw={500} pl={10} c={theme.colors.blue[8]}>
								{projectSubmission.dateSubmitted ? new Date(projectSubmission.dateSubmitted).toDateString() : "Date not available"}
							</Text>
						</Stack>
					</Card.Section>
				</Card>
			</Group>
			<ProjectSubmissionVideoModal setShowModal={setShowModal} isOpen={showModal} projectSubmission={projectSubmission} />
		</>
	)
}

export default VideoBlock;